// ** React Imports
import { useDispatch, useSelector } from "react-redux";
import { setAPIUsers } from "@src/views/user/store";

export const useUsers = () => {
    // ** Hooks
    const dispatch = useDispatch();
    const usersAPI = useSelector((state) => state.users.usersAPI);

    const setAPI = usersAPI => {
        dispatch(setAPIUsers({
            usersAPI
        }));
    };

    return { usersAPI, setAPI };
};
